import {Model} from './model';
import {Unserializer} from './serialization';

export class EmailTemplate implements Model {
  emailTemplateId: number;
  name: string;
  description: string;
  subject: string;
  message: string;
  created: Date;

  static copy(oldObj: EmailTemplate): EmailTemplate {
    const newObj = new EmailTemplate();
    newObj.emailTemplateId = oldObj.emailTemplateId;
    newObj.name = oldObj.name;
    newObj.description = oldObj.description;
    newObj.subject = oldObj.subject;
    newObj.message = oldObj.message;
    newObj.created = Unserializer.date(oldObj.created);
    return newObj;
  }

  public getPrimaryKey(): number {
    return this.emailTemplateId;
  }

  isNew(): boolean {
    return isNaN(this.emailTemplateId);
  }

  clone(): EmailTemplate {
    return EmailTemplate.copy(this);
  }
}
